import alertaSound from 'src/assets/alerta.mp3';
import messageSound from 'src/assets/message.mp3';
import chamadoSound from 'src/assets/som-chamado.mp3';

const SRC = {
  message: messageSound,
  queue: alertaSound,
  ticket: chamadoSound,
};

// Uma rajada de mensagens disparava um <audio> por evento e virava ruido.
const COOLDOWN_MS = 1500;

const elementos = {};
const ultimoPlay = {};
const listeners = new Set();

let destravado = false;
let bloqueado = false;

// Os handlers antigos faziam document.createElement('audio') + appendChild a
// cada evento e contavam com o onended para limpar; quando o play falhava, o
// <audio> ficava pendurado no body para sempre. Aqui o elemento e criado uma vez
// por tipo e nunca entra no DOM.
const obterElemento = (kind) => {
  if (!elementos[kind]) {
    const audio = new Audio(SRC[kind]);
    audio.preload = 'auto';
    elementos[kind] = audio;
  }
  return elementos[kind];
};

// Fail-open de proposito: a chave `soundNotification` so e escrita no login, e
// uma sessao aberta antes disso ficava permanentemente muda com o `=== "true"`
// que existia antes.
export const isSoundEnabled = () => {
  try {
    return localStorage.getItem('soundNotification') !== 'false';
  } catch {
    return true;
  }
};

export function setSoundEnabled(valor) {
  const ligado = Boolean(valor);
  try {
    localStorage.setItem('soundNotification', ligado ? 'true' : 'false');
  } catch (err) {
    console.debug('[notificacoes] nao foi possivel gravar soundNotification', err);
  }

  listeners.forEach((cb) => {
    try {
      cb(ligado);
    } catch (err) {
      console.debug('[notificacoes] listener de som falhou', err);
    }
  });

  // Telas que ainda nao usam o hook conseguem reagir sem recarregar a pagina.
  window.dispatchEvent(new CustomEvent('lais:sound-changed', { detail: { enabled: ligado } }));

  if (ligado) unlockAudio();
  return ligado;
}

export function subscribeSound(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/**
 * Destrava o autoplay. Chrome/Safari so liberam audio depois de um gesto do
 * usuario na pagina; sem isso o primeiro alerta da sessao e engolido em silencio.
 * Toca mudo uma vez em cada elemento no primeiro clique/tecla.
 */
export function unlockAudio() {
  if (destravado) return;
  destravado = true;

  Object.keys(SRC).forEach((kind) => {
    const audio = obterElemento(kind);
    const volumeOriginal = audio.volume;
    audio.volume = 0;

    const restaurar = () => {
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch {
        // Alguns navegadores reclamam de currentTime antes do metadata carregar.
      }
      audio.volume = volumeOriginal;
    };

    try {
      const p = audio.play();
      if (p && typeof p.then === 'function') {
        p.then(restaurar).catch(() => {
          audio.volume = volumeOriginal;
        });
      } else {
        restaurar();
      }
    } catch {
      audio.volume = volumeOriginal;
    }
  });

  bloqueado = false;
}

export function playAlert(kind = 'message') {
  const tipo = SRC[kind] ? kind : 'message';
  if (!isSoundEnabled()) return false;

  const agora = Date.now();
  if (agora - (ultimoPlay[tipo] || 0) < COOLDOWN_MS) return false;
  ultimoPlay[tipo] = agora;

  const audio = obterElemento(tipo);
  try {
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === 'function') {
      p.catch((err) => {
        // NotAllowedError = autoplay bloqueado ate o primeiro gesto do usuario.
        if (err?.name === 'NotAllowedError') bloqueado = true;
        console.debug('[notificacoes] audio nao tocou', err?.name);
      });
    }
    return true;
  } catch (err) {
    console.debug('[notificacoes] falha ao tocar audio', err);
    return false;
  }
}

export const isAudioBlocked = () => bloqueado;
